import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'app/services/admin/master-data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  settingData: any;
  activeTrackingContact: { email?: string; phone?: string } | null = null;

  constructor(private _masterDataService: MasterDataService) { }

  ngOnInit(): void {
    this._masterDataService.getMasterData().subscribe({
      next: (res) => {
        this.settingData = res?.data;
      }
    });

    this._masterDataService.activeTrackingContact$.subscribe((contact) => {
      this.activeTrackingContact = contact;
    });
  }

  get displayEmail(): string {
    if (this.activeTrackingContact && this.activeTrackingContact.email) {
      return this.activeTrackingContact.email;
    }
    return this.settingData?.email || '-';
  }

  get displayPhone(): string {
    if (this.activeTrackingContact && this.activeTrackingContact.phone) {
      return this.activeTrackingContact.phone;
    }
    return this.settingData?.mobile_no || '-';
  }
}
